import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { ticketId } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.SUPPORT_TICKETS_ADD_MESSAGE || `/support-ticket/add/message/:ticketId`, {
      pathParams: { ticketId }
    })
  },

  method() {
    return 'POST'
  },

  format(payload) {
    const { userId, subject, text } = payload || {}
    return {
      userId: userId || 'admin',
      subject: subject || 'Message support',
      message: text || '',
      senderName: 'Admin',
      senderRole: 'admin'
    }
  },

  parse(raw) {
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de l\'envoi du message',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'ok',
      data: raw.data
    }
  },
}
